import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { getOffersList } from '../actions';
import { workerGetOffersListSaga } from './workers';

export default function* watchOffers(): SagaIterator {
  yield takeLatest(getOffersList, workerGetOffersListSaga);
}
